import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    this.updateVideoPlayback();
  }

  updatedCallback() {
    super.updatedCallback();

    this.updateVideoPlayback();
  }

  /**
   * Updates source URLs after section re-renders, then reloads and starts playback.
   */
  updateVideoPlayback() {
    const { videoSources, videoElement } = this.refs;

    videoElement.muted = true;
    videoElement.playsInline = true;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();

    const playPromise = videoElement.play();

    if (playPromise instanceof Promise) {
      void playPromise.catch(() => null);
    }
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
